export const HISTORY_SIDE_PANEL_BREAKPOINT = 900;

export const STOP_RUNNING_CHAT_TITLE = "Stop the running chat?";

export const STOP_RUNNING_CHAT_DESCRIPTION =
  "Infra Assistant is still working on this chat. If you leave it, it will stop.";

export const STOP_RUNNING_CHAT_CONFIRMATION_LABEL = "Stop chat";
